import React from "react";
import { Link, Icon } from "@telia/teddy";

interface BackLinkProps {
    href: string;
    path: string;
    text: string;
}

const BackLink: React.FC<BackLinkProps> = ({ href, text }) => {
    const handleGoTo = async (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        if (href) {
            window.location.assign(href);
        } else {
            window.history.back();
        }
    };

    return (
        <Link variant="standalone" href="#" onClick={handleGoTo}>
            <Icon name="arrow-left" />
            {text}
        </Link>
    );
};

export default BackLink;
